import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { getBrandingColor, colorTypes } from 'src/branding';
import { usePageSize } from 'src/utils/hooks';
import Button from './Button';
import { useOnClickOutside } from '../hooks/hooks';

export const Bubble = styled.div`
  position: relative;
  border-radius: 50%;
  color: ${getBrandingColor(colorTypes.primary)};
  border: 1.2px solid ${getBrandingColor(colorTypes.primary)};
  height: 0.75em;
  width: 0.75em;
  font-weight: bold;
  text-align: center;

  padding: 0.05em;
  font-weight: bold;
  font-size: 1.1em;

  :hover {
    cursor: pointer;
  }

  span {
    font-size: 0.6em;
    position: absolute;
    top: 50%;
    line-height: 0;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const Popup = styled.div`
  position: absolute;
  border-radius: 6px;
  border: 1px solid ${getBrandingColor(colorTypes.infoBubbleBorder)};
  padding: 10px 14px;
  position: absolute;
  top: ${({ top }) => (top ? top : '10px')};
  left: ${({ left }) => (left ? left : '0')};
  position: relative;
  background: white;
  z-index: 2;
  word-break: normal;
  white-space: normal;
  word-wrap: normal;

  min-width: 11em;
  width: 100%;
  max-width: 495px;
 
`;

export const InfoBubble = ({
  children,
  ariaLabel,
  topModal,
  leftModal,
  popupStyle,
  popupStyleMobile,
  className,
  ...props
}) => {
  const [displayPopup, setDisplayPopup] = useState(false);
  const ref = useRef();
  const pageSize = usePageSize();

  useOnClickOutside(() => setDisplayPopup(false), [ref]);

  return (
    <div
      className={className || ''}
      style={{ position: 'absolute', display: 'inline-block', ...props.style }}
    >
      <Bubble
        aria-label={ariaLabel || 'informasjon'}
        role="button"
        onClick={() => setDisplayPopup(true)}
      >
        <span aria-hidden="true">?</span>
      </Bubble>
      {displayPopup && (
        <Popup
          role="modal"
          top={topModal}
          className="popup"
          left={leftModal}
          style={{ ...popupStyle, ...pageSize?.width < 570 ? popupStyleMobile : {} }}
          ref={ref}
        >
          {children}
          <Button
            secondary
            style={{ padding: '7px 0', width: '100%' }}
            aria-label="Lukk modal"
            onClick={() => setDisplayPopup(false)}
          >
            Lukk
          </Button>
        </Popup>
      )}
    </div>
  );
};
